(() => {
  const formSelector = 'form[data-type="leotara-single-quantity-checkout"]';
  const root = window.Shopify?.routes?.root || '/';
  const locks = new Map();

  const cartRequest = async (path, body) => {
    const response = await fetch(`${root}${path}`, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        ...(body ? { 'Content-Type': 'application/json' } : {}),
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });

    if (!response.ok) throw new Error('Shopify cart request failed');
    return response.json();
  };

  const matchingLines = (cart, variantId) =>
    cart.items.filter((item) => String(item.variant_id) === variantId);

  const enforceSingleQuantity = async (variantId) => {
    let cart = await cartRequest('cart.js');
    let lines = matchingLines(cart, variantId);

    if (lines.length === 0) {
      await cartRequest('cart/add.js', {
        items: [{ id: Number(variantId), quantity: 1 }],
      });
    } else {
      for (let index = 0; index < lines.length; index += 1) {
        await cartRequest('cart/change.js', {
          id: lines[index].key,
          quantity: index === 0 ? 1 : 0,
        });
      }
    }

    cart = await cartRequest('cart.js');
    lines = matchingLines(cart, variantId);
    const totalQuantity = lines.reduce((sum, item) => sum + item.quantity, 0);

    if (totalQuantity !== 1) {
      throw new Error('Single-quantity checkout invariant failed');
    }
  };

  const setPending = (pending) => {
    document.querySelectorAll(`${formSelector} button[type="submit"]`).forEach((button) => {
      if (!button.dataset.leotaraOriginalLabel) {
        button.dataset.leotaraOriginalLabel = button.innerHTML;
      }
      button.disabled = pending;
      button.setAttribute('aria-busy', pending ? 'true' : 'false');
      if (pending) button.textContent = 'Preparing secure checkout…';
      else button.innerHTML = button.dataset.leotaraOriginalLabel;
    });
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest?.(formSelector);
      if (!form) return;

      event.preventDefault();
      const variantId = form.querySelector('input[name="id"]')?.value;
      if (!variantId || locks.has(variantId)) return;

      setPending(true);
      const task = enforceSingleQuantity(variantId)
        .then(() => window.location.assign(`${root}checkout`))
        .catch(() => {
          setPending(false);
          const button = form.querySelector('button[type="submit"]');
          if (button) button.textContent = 'Checkout unavailable — try again';
        })
        .finally(() => locks.delete(variantId));

      locks.set(variantId, task);
    },
    true,
  );
})();
